module.exports = __webpack_public_path__ + "media/images/swines/11 to 12 week pregnant swine.jpg";